import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-4 row g-5 g-xl-10" }
const _hoisted_2 = { class: "col-xl-6 mb-xl-10" }
const _hoisted_3 = { class: "card card-flush h-xl-100" }
const _hoisted_4 = { class: "card-header rounded bgi-no-repeat bgi-size-cover bgi-position-y-top bgi-position-x-center align-items-start h-250px" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column pt-15" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "position-relative d-inline-block" }, " Stats ")
  ])
], -1)
const _hoisted_6 = { class: "card-toolbar pt-5" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<button class=\"btn btn-sm btn-icon btn-active-color-primary btn-color-danger bg-white bg-opacity-25 bg-hover-opacity-100 bg-hover-white bg-active-opacity-25 w-20px h-20px\" data-kt-menu-trigger=\"click\" data-kt-menu-placement=\"bottom-end\" data-kt-menu-overflow=\"true\"><span class=\"svg-icon svg-icon-4\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"10\" y=\"10\" width=\"4\" height=\"4\" rx=\"2\" fill=\"currentColor\"></rect><rect x=\"17\" y=\"10\" width=\"4\" height=\"4\" rx=\"2\" fill=\"currentColor\"></rect><rect x=\"3\" y=\"10\" width=\"4\" height=\"4\" rx=\"2\" fill=\"currentColor\"></rect></svg></span></button>", 1)
const _hoisted_8 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px",
  "data-kt-menu": "true",
  style: {}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-content fs-6 text-dark fw-bold px-3 py-4" }, " Quick Actions ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_11 = { class: "menu-item px-3" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("New Material")
const _hoisted_13 = { class: "menu-item px-3" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("New Party")
const _hoisted_15 = { class: "menu-item px-3" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("New Design")
const _hoisted_17 = { class: "menu-item px-3" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("New Production")
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("New Unused Stock")
const _hoisted_21 = { class: "card-body mt-n20" }
const _hoisted_22 = { class: "mt-n20 position-relative" }
const _hoisted_23 = { class: "row g-3 g-lg-6" }
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = { class: "bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5" }
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"symbol symbol-30px me-5 mb-8\"><span class=\"symbol-label\"><span class=\"svg-icon svg-icon-1 svg-icon-primary\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path opacity=\"0.3\" d=\"M17.9061 13H11.2061C11.2061 12.4 10.8061 12 10.2061 12C9.60605 12 9.20605 12.4 9.20605 13H6.50606L9.20605 8.40002V4C8.60605 4 8.20605 3.6 8.20605 3C8.20605 2.4 8.60605 2 9.20605 2H15.2061C15.8061 2 16.2061 2.4 16.2061 3C16.2061 3.6 15.8061 4 15.2061 4V8.40002L17.9061 13ZM13.2061 9C12.6061 9 12.2061 9.4 12.2061 10C12.2061 10.6 12.6061 11 13.2061 11C13.8061 11 14.2061 10.6 14.2061 10C14.2061 9.4 13.8061 9 13.2061 9Z\" fill=\"currentColor\"></path><path d=\"M18.9061 22H5.40605C3.60605 22 2.40606 20 3.30606 18.4L6.40605 13H9.10605C9.10605 13.6 9.50605 14 10.106 14C10.706 14 11.106 13.6 11.106 13H17.8061L20.9061 18.4C21.9061 20 20.8061 22 18.9061 22ZM14.2061 15C13.1061 15 12.2061 15.9 12.2061 17C12.2061 18.1 13.1061 19 14.2061 19C15.3061 19 16.2061 18.1 16.2061 17C16.2061 15.9 15.3061 15 14.2061 15Z\" fill=\"currentColor\"></path></svg></span></span></div>", 1)
const _hoisted_27 = { class: "m-0" }
const _hoisted_28 = { class: "text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 fw-semibold fs-6" }, "Design", -1)
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = { class: "bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5" }
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"symbol symbol-30px me-5 mb-8\"><span class=\"symbol-label\"><span class=\"svg-icon svg-icon-1 svg-icon-primary\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z\" fill=\"currentColor\"></path><path opacity=\"0.3\" d=\"M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z\" fill=\"currentColor\"></path></svg></span></span></div>", 1)
const _hoisted_33 = { class: "m-0" }
const _hoisted_34 = { class: "text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 fw-semibold fs-6" }, "Material", -1)
const _hoisted_36 = { class: "col-6" }
const _hoisted_37 = { class: "bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5" }
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"symbol symbol-30px me-5 mb-8\"><span class=\"symbol-label\"><span class=\"svg-icon svg-icon-1 svg-icon-primary\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 18V16H10V18L9 20H15L14 18Z\" fill=\"currentColor\"></path><path opacity=\"0.3\" d=\"M20 4H17V3C17 2.4 16.6 2 16 2H8C7.4 2 7 2.4 7 3V4H4C3.4 4 3 4.4 3 5V9C3 11.2 4.8 13 7 13C8.2 14.2 8.8 14.8 10 16H14C15.2 14.8 15.8 14.2 17 13C19.2 13 21 11.2 21 9V5C21 4.4 20.6 4 20 4ZM5 9V6H7V11C5.9 11 5 10.1 5 9ZM19 9C19 10.1 18.1 11 17 11V6H19V9ZM17 21V22H7V21C7 20.4 7.4 20 8 20H16C16.6 20 17 20.4 17 21ZM10 9C9.4 9 9 8.6 9 8V5C9 4.4 9.4 4 10 4C10.6 4 11 4.4 11 5V8C11 8.6 10.6 9 10 9ZM10 13C9.4 13 9 12.6 9 12V11C9 10.4 9.4 10 10 10C10.6 10 11 10.4 11 11V12C11 12.6 10.6 13 10 13Z\" fill=\"currentColor\"></path></svg></span></span></div>", 1)
const _hoisted_39 = { class: "m-0" }
const _hoisted_40 = { class: "text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 fw-semibold fs-6" }, "Party", -1)
const _hoisted_42 = { class: "col-6" }
const _hoisted_43 = { class: "bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5" }
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<div class=\"symbol symbol-30px me-5 mb-8\"><span class=\"symbol-label\"><span class=\"svg-icon svg-icon-1 svg-icon-primary\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path opacity=\"0.3\" d=\"M20.9 12.9C20.3 12.9 19.9 12.5 19.9 11.9C19.9 11.3 20.3 10.9 20.9 10.9H21.8C21.3 6.2 17.6 2.4 12.9 2V2.9C12.9 3.5 12.5 3.9 11.9 3.9C11.3 3.9 10.9 3.5 10.9 2.9V2C6.19999 2.5 2.4 6.2 2 10.9H2.89999C3.49999 10.9 3.89999 11.3 3.89999 11.9C3.89999 12.5 3.49999 12.9 2.89999 12.9H2C2.5 17.6 6.19999 21.4 10.9 21.8V20.9C10.9 20.3 11.3 19.9 11.9 19.9C12.5 19.9 12.9 20.3 12.9 20.9V21.8C17.6 21.3 21.4 17.6 21.8 12.9H20.9Z\" fill=\"currentColor\"></path><path d=\"M16.9 10.9H13.6C13.4 10.6 13.2 10.4 12.9 10.2V5.90002C12.9 5.30002 12.5 4.90002 11.9 4.90002C11.3 4.90002 10.9 5.30002 10.9 5.90002V10.2C10.6 10.4 10.4 10.6 10.2 10.9H9.89999C9.29999 10.9 8.89999 11.3 8.89999 11.9C8.89999 12.5 9.29999 12.9 9.89999 12.9H10.2C10.4 13.2 10.6 13.4 10.9 13.6V13.9C10.9 14.5 11.3 14.9 11.9 14.9C12.5 14.9 12.9 14.5 12.9 13.9V13.6C13.2 13.4 13.4 13.2 13.6 12.9H16.9C17.5 12.9 17.9 12.5 17.9 11.9C17.9 11.3 17.5 10.9 16.9 10.9Z\" fill=\"currentColor\"></path></svg></span></span></div>", 1)
const _hoisted_45 = { class: "m-0" }
const _hoisted_46 = { class: "text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 fw-semibold fs-6" }, "Production", -1)
const _hoisted_48 = { class: "col-xl-6 mb-xl-10" }
const _hoisted_49 = { class: "col-xl-6 mb-xl-10" }
const _hoisted_50 = { class: "col-xl-6 mb-xl-10" }
const _hoisted_51 = { class: "col-xl-6 mb-xl-10" }
const _hoisted_52 = { class: "col-xl-6 mb-xl-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PieChart = _resolveComponent("PieChart")!
  const _component_Graph = _resolveComponent("Graph")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_router_link, {
                    to: "/material/add",
                    class: "menu-link px-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_router_link, {
                    to: "/party/add",
                    class: "menu-link px-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_router_link, {
                    to: "/design/add",
                    class: "menu-link px-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_router_link, {
                    to: "/production/add",
                    class: "menu-link px-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_router_link, {
                    to: "/unused-stock/add",
                    class: "menu-link px-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.totalCount.design), 1),
                      _hoisted_29
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.totalCount.material), 1),
                      _hoisted_35
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.totalCount.party), 1),
                      _hoisted_41
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.totalCount.production), 1),
                      _hoisted_47
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createVNode(_component_PieChart)
      ]),
      _createElementVNode("div", _hoisted_49, [
        _createVNode(_component_Graph, {
          title: "Material",
          moduleName: "material"
        })
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createVNode(_component_Graph, {
          title: "Design",
          moduleName: "design"
        })
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createVNode(_component_Graph, {
          title: "Production",
          moduleName: "production"
        })
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createVNode(_component_Graph, {
          title: "Unused Stock",
          moduleName: "unused-stock"
        })
      ])
    ])
  ]))
}